import React, { useEffect, useState } from "react";
import { Space } from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  // EyeOutlined,
  // LineChartOutlined,
  // LockOutlined,
  // MailOutlined,
  // UnlockOutlined,
} from "@ant-design/icons";
import DataTable from "../../components/Comman/CustomTable/CommonTable";
import { useDispatch, useSelector } from "react-redux";
import { budgetListAction, deleteBudget } from "../../actions/admin";
import Button from "../../components/Button/Button";
import SideDrawer from "../../components/Comman/Drawer/SideDrawer";
import ConfirmDeleteModal from "../../components/Comman/ConfirmDeleteModal/ConfirmDeleteModal";
import { formatDateTimeToCST, monthName } from "../../utils/comman";

const Budgets = () => {
  const dispatch = useDispatch<any>();
  const [loading, setLoading] = useState<boolean>(true);
  const user = useSelector((state: any) => state?.Auth?.user);
  const roleId = user?.user?.roleId;
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [deleteModelVisible, setDeleteModelVisible] = useState<boolean>(false);
  const [selectedBudget, setSelectedBudget] = useState<any>(null);
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
  const [tableData, setTableData] = useState<any[]>([]);
  const [sortConfig, setSortConfig] = useState<{
    field: string | null;
    order: "asc" | "desc" | null;
  }>({
    field: null,
    order: null,
  });
  const handleRefresh = useSelector(
    (state: any) => state?.General?.updateListing
  );
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchDataElementList = (params = {}) => {
    setLoading(true);
    const requestParams = {
      ...params,
    };
    dispatch(
      budgetListAction(requestParams, (resp: any) => {
        setLoading(false);
        if (resp?.status === 200) {
          setTableData(resp?.data || []);
          setPagination({
            ...pagination,
            total: resp.pagination?.totalItems,
            current: resp.pagination?.currentPage,
            pageSize: resp.pagination?.pageSize,
          });
        }
      })
    );
  };

  useEffect(() => {
    fetchDataElementList({
      page: pagination.current || 1,
      limit: pagination.pageSize || 10,
    });
  }, [handleRefresh]);

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    let newSortConfig = { ...sortConfig };
    if (sorter && Object.keys(sorter).length > 0) {
      newSortConfig = {
        field: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      };
    }
    setSortConfig(newSortConfig);
    fetchDataElementList({
      page: pagination.current || 1,
      limit: pagination.pageSize || 10,
      ...(newSortConfig.field && newSortConfig.order
        ? {
            sort: newSortConfig.field,
            order: newSortConfig.order,
          }
        : {}),
    });
  };

  const handleIsModelOpen: any = () => {
    setIsModalOpen(!isModalOpen);

    setSelectedBudget({});
  };

  const handleDeleteModel = (id?: number) => {
    if (id) setSelectedUserId(id); // Store the selected user ID
    setDeleteModelVisible(!deleteModelVisible);
  };

  const handleEditClick = (record: any) => {
    handleIsModelOpen();
    // setDisableFields(true)
    setSelectedBudget(record); // Store the selected organization's data
  };

  const handleBudgetDeletion = () => {
    setLoading(true); // Show loading indicator before making the API call
    dispatch(
      deleteBudget(selectedUserId, (resp: any) => {
        setLoading(false); // Hide loading indicator once the API call is completed
        if (resp?.status === 200) {
          // User deleted successfully, handle UI update if needed
          handleDeleteModel();
        } else {
          handleDeleteModel();
        }
      })
    );
  };

  const columns = [
    {
      title: "Org Name",
      dataIndex: "organizationName",
      key: "orgName",
      render: (_, record) => {
        return record?.organization?.name || "-"; // ✅ Returns org name dynamically
      },
      sorter: true,
      className: "no-break",
    },

    // {
    //   title: "Org Leader",
    //   dataIndex: "leader",
    //   key: "orgLeader",
    //   render: (_, data) => {
    //     const leader = data?.organization?.organizationAssignment?.find(
    //       (assignment) => assignment?.user?.roleId === 2
    //     )?.user?.name;

    //     return leader || "-";
    //   },
    //   sorter: true,
    // },

    {
      title: "Budgeted Data Element",
      dataIndex: "budgetedDataElement",
      key: "budgetedDataElement",
      render: (_, record) => {
        return record?.dataElement?.DataElements_Name;
      },
    },
    {
      title: "Budget Data Year",
      dataIndex: "BudgetData_Year",
      key: "BudgetData_Year",
    },
    {
      title: "Data Period",
      dataIndex: "BudgetData_Period",
      key: "BudgetData_Period",
      render: (data) => monthName[data] || "-",
    },
    {
      title: "Amount",
      dataIndex: "BudgetData_Amount",
      key: "BudgetData_Amount",
      // render: (amount) =>
      //   amount !== undefined && amount !== null
      //     ? `$ ${parseFloat(amount).toLocaleString(undefined, {
      //         minimumFractionDigits: 2,
      //         maximumFractionDigits: 10, // Allows showing more if present
      //       })}`
      //     : "-",
      render: (amount) => (
        <div className="text-right">
          {amount !== undefined && amount !== null
            ? `$ ${parseFloat(amount).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 10,
              })}`
            : "-"}
        </div>
      ),
    },
    {
      title: "Last Updated",
      dataIndex: "BudgetData_LastUpdated",
      key: "BudgetData_LastUpdated",
      render: (data) => formatDateTimeToCST(data) || "-",
    },
    {
      title: "Last Updated By",
      dataIndex: "BudgetData_LastUpdatedBy",
      key: "BudgetData_LastUpdatedBy",
      render: (_, data) => {
        return data?.updatedBy?.email || "-";
      },
    },
    // {
    //   title: "Status",
    //   key: "status",
    //   render: (record: any) => (
    //     <>
    //       {record.status === "Active" ? (
    //         <Tag color="green">Active</Tag>
    //       ) : record.status === "Pending" ? (
    //         <Tag color="red">Pending</Tag>
    //       ) : record.status === "Completed" ? (
    //         <Tag color="green">Completed</Tag>
    //       ) : record.status === "Inactive" ? (
    //         <Tag color="red">Inactive</Tag>
    //       ) : (
    //         <Tag color="default">Unknown</Tag> // Default case for unexpected values
    //       )}
    //     </>
    //   ),
    // },
    {
      title: "Action",
      key: "action",
      render: (record: any) => (
        <Space size="middle">
          <span
            style={{ color: "#3DA57F", fontWeight: "bold", fontSize: "16px" }}
          >
            <EditOutlined
              onClick={() => {
                handleEditClick(record);
              }}
            />
          </span>
          {/* <span
            style={{ color: "#3DA57F", fontWeight: "bold", fontSize: "16px" }}
          >
            <EyeOutlined />
          </span> */}
          <span
            style={{ color: "#3DA57F", fontWeight: "bold", fontSize: "16px" }}
          >
            <DeleteOutlined onClick={() => handleDeleteModel(record?.id)} />
          </span>
          {/* <span
            style={{ color: "#3DA57F", fontWeight: "bold", fontSize: "16px" }}
          >
            <LineChartOutlined />
          </span>
          <span
            style={{ color: "#3DA57F", fontWeight: "bold", fontSize: "16px" }}
          >
            <MailOutlined />
          </span>
          <span
            style={{ color: "#3DA57F", fontWeight: "bold", fontSize: "16px" }}
          >
            <UnlockOutlined />
          </span>
          <span
            style={{ color: "#3DA57F", fontWeight: "bold", fontSize: "16px" }}
          >
            <LockOutlined />
          </span> */}
        </Space>
      ),
    },
  ];

  return (
    <div>
      {/* <Header /> */}

      <div className="flex justify-between">
        <h1 className="text-3xl font-bold text-left mb-6 text-white">
          Budgets
        </h1>
        {/* {[1, 2, 3].includes(roleId) && ( */}
        {[1, 2, 3].includes(roleId) && (
          <div>
            <Button
              buttonText="Create Budget"
              padding="p-[12px] 2xl:p-[15px]"
              text="text-[12px]"
              handleIsModelOpen={handleIsModelOpen}
              type="button"
            />
          </div>
        )}
      </div>
      <div className="table-col">
        <DataTable
          columns={columns}
          data={tableData}
          loading={loading}
          rowKey="id"
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
          }}
          onTableChange={handleTableChange}
        />
      </div>
      <SideDrawer
        open={isModalOpen}
        onClose={handleIsModelOpen}
        type={"budget"}
        organizationData={selectedBudget} // Pass only selected record
      />
      {deleteModelVisible && (
        <ConfirmDeleteModal
          handleConfirmDeleteModel={handleDeleteModel}
          type="delete"
          handleModelFunction={handleBudgetDeletion}
        />
      )}
    </div>
  );
};

export default Budgets;
